import actions from './actions'

const socials = {
    namespaced: true,
    actions
}

export default socials
